import axios from 'axios'

export var SESSION_TOKEN_CACHE = { value: '' }

export async function setSessionToken() {
  try {
    if (SESSION_TOKEN_CACHE.value) return SESSION_TOKEN_CACHE.value
    SESSION_TOKEN_CACHE.value = ''
    const sessionResponse = await axios.get('/session-token')
    console.log('Session response:', sessionResponse.data)
    if (sessionResponse.data && sessionResponse.data.session_id) {
      SESSION_TOKEN_CACHE.value = sessionResponse.data.session_id
    }
  } catch (error) {
    console.error('Failed to initialize session token:', error)
    // Don't fail the auth process if session token fails
  }
}

export const getSessionToken = async () =>
  new Promise((resolve) => {
    if (SESSION_TOKEN_CACHE.value) return resolve(SESSION_TOKEN_CACHE.value)
    // A 401 handler clears the cache; without a re-fetch the poll below never resolves.
    setSessionToken()
    const timerID = setInterval(() => {
      if (SESSION_TOKEN_CACHE.value) {
        clearInterval(timerID)
        resolve(SESSION_TOKEN_CACHE.value)
      }
    }, 1000)
  })
